/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
import type { KokpitFeatureListDto } from './KokpitFeatureListDto';
import {
    KokpitFeatureListDtoFromJSON,
    KokpitFeatureListDtoFromJSONTyped,
    KokpitFeatureListDtoToJSON,
} from './KokpitFeatureListDto';

/**
 * 
 * @export
 * @interface KokpitModuleUpdateDto
 */
export interface KokpitModuleUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof KokpitModuleUpdateDto
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof KokpitModuleUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof KokpitModuleUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KokpitModuleUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<KokpitFeatureListDto>}
     * @memberof KokpitModuleUpdateDto
     */
    features?: Array<KokpitFeatureListDto> | null;
}

/**
 * Check if a given object implements the KokpitModuleUpdateDto interface.
 */
export function instanceOfKokpitModuleUpdateDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function KokpitModuleUpdateDtoFromJSON(json: any): KokpitModuleUpdateDto {
    return KokpitModuleUpdateDtoFromJSONTyped(json, false);
}

export function KokpitModuleUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KokpitModuleUpdateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenantId': !exists(json, 'tenantId') ? undefined : json['tenantId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'features': !exists(json, 'features') ? undefined : (json['features'] === null ? null : (json['features'] as Array<any>).map(KokpitFeatureListDtoFromJSON)),
    };
}

export function KokpitModuleUpdateDtoToJSON(value?: KokpitModuleUpdateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenantId': value.tenantId,
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'features': value.features === undefined ? undefined : (value.features === null ? null : (value.features as Array<any>).map(KokpitFeatureListDtoToJSON)),
    };
}

